// purely.: oppsalg i handlekurven (snippets/purely-kurv-hjelp.liquid). Lastes med skuffen og kurvsiden.
// Definisjonen ligger her og ikke i snippeten, fordi Dawn setter inn skuffen på nytt med innerHTML, og da kjører ikke skript.
if (!customElements.get('purely-oppsalg')) {
  customElements.define(
    'purely-oppsalg',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', async (e) => {
          const knapp = e.target.closest('[data-oppsalg-id]');
          if (!knapp || knapp.disabled) return;
          knapp.disabled = true;
          knapp.setAttribute('aria-busy', 'true');
          // På kurvsiden lastes siden på nytt. I skuffen tegnes skuffen på nytt med svaret fra Shopify
          const skuff = document.getElementById('main-cart-items') ? null : document.querySelector('cart-drawer');
          const body = { items: [{ id: Number(knapp.dataset.oppsalgId), quantity: 1 }] };
          if (skuff) {
            body.sections = skuff.getSectionsToRender().map((s) => s.id);
            body.sections_url = window.location.pathname;
          }
          try {
            const svar = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(body),
            });
            const data = await svar.json();
            if (!svar.ok || data.status) throw new Error(data.description || 'Kunne ikke legge til');
            if (skuff && data.sections) {
              skuff.renderContents(data);
            } else {
              window.location.reload();
            }
          } catch (feil) {
            knapp.disabled = false;
            knapp.removeAttribute('aria-busy');
            knapp.textContent = 'Prøv igjen';
          }
        });
      }
    }
  );
}
